var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCapFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "245 62 236.624 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80c343;\n      }\n\n      .cls-2 {\n        fill: #2e9646;\n      }\n\n      .cls-3 {\n        fill: #42473f;\n      }\n\n      .cls-4 {\n        fill: #c9da30;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(245 62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-1",
    d: "M36.54,57.77a2.047,2.047,0,0,0,1.932-2.254V51.654A2.047,2.047,0,0,0,36.54,49.4H1.932A2.047,2.047,0,0,0,0,51.654v3.863A2.047,2.047,0,0,0,1.932,57.77H36.54Z",
    transform: "translate(0 30.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-1",
    d: "M36.54,49.17a2.047,2.047,0,0,0,1.932-2.254V43.054A2.047,2.047,0,0,0,36.54,40.8H1.932A2.047,2.047,0,0,0,0,43.054v3.863A2.145,2.145,0,0,0,1.932,49.17Z",
    transform: "translate(0 24.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-2",
    d: "M33.16,31.254A2.2,2.2,0,0,0,30.906,29H2.254A2.3,2.3,0,0,0,0,31.254v3.863A2.2,2.2,0,0,0,2.254,37.37H30.906a2.2,2.2,0,0,0,2.254-2.254V31.254Z",
    transform: "translate(0 17.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-2",
    d: "M33.16,22.654A2.2,2.2,0,0,0,30.906,20.4H2.254A2.2,2.2,0,0,0,0,22.654v3.863A2.2,2.2,0,0,0,2.254,28.77H30.906a2.2,2.2,0,0,0,2.254-2.254V22.654Z",
    transform: "translate(0 12.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-3",
    d: "M59.829,6.739c0,4.829-2.9,6.761-7.726,6.761H50.171v8.531H48.4V.3h3.863c4.99,0,7.566,2.093,7.566,6.439m-1.932,0c0-3.541-1.932-4.99-5.795-4.99H50.171V11.89H52.1c3.7.161,5.795-1.127,5.795-5.151",
    transform: "translate(29.509 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-3",
    d: "M67.607,16.075H59.88l-1.61,5.956H56.5L62.778.3h2.254l6.117,21.731H69.217Zm-.322-1.61L63.744,1.749l-3.38,12.717Z",
    transform: "translate(34.447 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-3",
    d: "M77.941,22.031l-4.829-9.819H69.571v9.819H67.8V.3h4.185c4.99,0,7.244,2.093,7.244,5.956a5.3,5.3,0,0,1-4.185,5.634l5.151,10.141Zm-.8-15.775c0-2.9-1.288-4.346-5.312-4.346H69.571v9.014h2.576c3.219-.161,4.99-1.61,4.99-4.668",
    transform: "translate(41.337 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-3",
    d: "M88.917,1.91H83.444V22.031H81.673V1.91H76.2V.3H89.077Z",
    transform: "translate(46.458 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-3",
    d: "M95.536,1.749H87.971V9.958h6.6v1.61h-6.6v8.853h8.048v1.61H86.2V.3h9.658Z",
    transform: "translate(52.555 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-3",
    d: "M107.295,22.031H104.88L96.349,2.393a61.4,61.4,0,0,1,.322,7.244V22.031H94.9V.3h2.415l8.531,19.638c0-.966-.322-3.541-.322-6.278V.3h1.771V22.031Z",
    transform: "translate(57.859 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-3",
    d: "M115.907,16.075H108.18l-1.61,5.956H104.8L111.078.3h2.254l6.117,21.731h-1.932Zm-.483-1.61-3.38-12.717-3.38,12.717Z",
    transform: "translate(63.895 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-3",
    d: "M126.3,22.031l-4.829-9.819h-3.541v9.819H116V.3h4.185c4.99,0,7.244,2.093,7.244,5.956a5.3,5.3,0,0,1-4.185,5.634l5.151,10.141Zm-.8-15.775c0-2.9-1.288-4.346-5.312-4.346h-2.254v9.014h2.575c3.219-.161,4.99-1.61,4.99-4.668",
    transform: "translate(70.724 0.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    className: "cls-3",
    width: 1.771,
    height: 21.731,
    transform: "translate(202.82 0.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-3",
    d: "M140.507,16.075H132.78l-1.61,5.956H129.4L135.678.3h2.254l6.117,21.731h-1.932Zm-.483-1.61-3.38-12.717-3.38,12.717Z",
    transform: "translate(78.893 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-3",
    d: "M151.717,1.91H146.4V22.031h-1.932V1.91H139V.3h12.878Z",
    transform: "translate(84.746 0.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-3",
    d: "M32.5,61.126V40.361l1.771-.161V61.126c0,.966.322,1.449,1.127,1.449a2.042,2.042,0,0,0,.966-.161l.483,1.288a2.719,2.719,0,0,1-1.61.483A2.8,2.8,0,0,1,32.5,61.126",
    transform: "translate(19.815 24.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-3",
    d: "M39.719,41.488a3.706,3.706,0,0,1-.483,1.449L37.627,46.8H36.5l1.127-4.185a1.215,1.215,0,0,1-.644-1.127A1.185,1.185,0,0,1,38.271,40.2a1.316,1.316,0,0,1,1.449,1.288",
    transform: "translate(22.254 24.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-3",
    d: "M50.768,58H44.651l-1.127,4.99H39.5L45.295,41.1h4.829l5.795,21.892H51.734Zm-.644-3.058L47.709,44.319,45.295,54.943Z",
    transform: "translate(24.083 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-3",
    d: "M65.57,43.375l-2.093,2.093a5.492,5.492,0,0,0-3.863-1.61c-2.736,0-4.829,2.254-4.829,8.37s1.449,8.37,4.185,8.37a6.559,6.559,0,0,0,2.9-.8V54H59.292l-.483-3.058h6.922V61.565a11.89,11.89,0,0,1-6.6,2.093c-5.634,0-8.531-3.863-8.531-11.429,0-7.4,4.024-11.429,8.853-11.429a9.314,9.314,0,0,1,6.117,2.575",
    transform: "translate(30.85 24.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-3",
    d: "M68.517,54.3H66.424v8.853H62.4V41.1h5.473c5.473,0,8.048,2.254,8.048,6.439a5.631,5.631,0,0,1-3.7,5.795l4.829,9.658H72.7Zm-.483-3.058c2.575,0,3.7-1.127,3.7-3.7,0-2.415-1.127-3.541-3.863-3.541H66.424v7.244Z",
    transform: "translate(38.044 25.058)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    className: "cls-3",
    width: 4.024,
    height: 21.892,
    transform: "translate(117.507 66.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-3",
    d: "M91.643,43.154l-1.932,2.415a5.217,5.217,0,0,0-3.38-1.449c-2.576,0-4.346,2.093-4.346,8.209s1.771,8.209,4.507,8.209c1.61,0,2.576-.8,3.7-1.61l1.932,2.254a7.863,7.863,0,0,1-5.795,2.575c-4.99,0-8.531-3.7-8.531-11.429S81.341,40.9,86.17,40.9a7.4,7.4,0,0,1,5.473,2.254",
    transform: "translate(47.434 24.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-3",
    d: "M102.387,56.553c0,4.024-2.415,6.922-7.244,6.922s-7.244-2.9-7.244-6.922V41.1h4.024V56.231c0,2.736.966,4.024,3.058,4.024,2.254,0,3.058-1.288,3.058-4.024V41.1h4.024V56.553Z",
    transform: "translate(53.591 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-3",
    d: "M103.524,59.772h7.4l-.483,3.219H99.5V41.1h4.024Z",
    transform: "translate(60.664 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-3",
    d: "M120.943,44.319h-4.829V62.992H112.09V44.319H107.1V41.1h14.165Z",
    transform: "translate(65.297 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-3",
    d: "M131.687,56.553c0,4.024-2.415,6.922-7.244,6.922s-7.244-2.9-7.244-6.922V41.1h4.024V56.231c0,2.736.966,4.024,3.058,4.024,2.254,0,3.058-1.288,3.058-4.024V41.1h4.024V56.553Z",
    transform: "translate(71.455 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-3",
    d: "M134.817,54.3h-2.093v8.853H128.7V41.1h5.473c5.473,0,8.048,2.254,8.048,6.439a5.631,5.631,0,0,1-3.7,5.795l4.829,9.658H139Zm-.483-3.058c2.576,0,3.7-1.127,3.7-3.7,0-2.415-1.127-3.541-3.863-3.541h-1.449v7.244Z",
    transform: "translate(78.467 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-3",
    d: "M150.185,44.158h-6.761v6.278h5.956v3.058h-5.956v6.439h7.244v3.058H139.4V41.1h11.268Z",
    transform: "translate(84.99 25.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-3",
    d: "M43.543,22.515l-1.932,2.254a5.217,5.217,0,0,0-3.38-1.449c-2.575,0-4.346,2.093-4.346,8.209s1.771,8.209,4.507,8.209c1.61,0,2.575-.8,3.7-1.61l1.932,2.254a7.863,7.863,0,0,1-5.795,2.575c-4.99,0-8.531-3.7-8.531-11.429S33.241,20.1,38.07,20.1a8.563,8.563,0,0,1,5.473,2.415",
    transform: "translate(18.108 12.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-3",
    d: "M49.768,37.241H43.651l-1.127,5.151H38.5L44.295,20.5h4.829l5.795,21.892H50.734Zm-.644-3.058L46.709,23.558,44.456,34.182Z",
    transform: "translate(23.473 12.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-3",
    d: "M64.326,42.392H59.175L53.058,24.524c.161,1.932.483,4.668.483,8.692v9.175H50V20.5h5.151l6.117,17.868a64.491,64.491,0,0,1-.483-7.4V20.5h3.541Z",
    transform: "translate(30.484 12.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-3",
    d: "M71.368,37.241H65.251l-1.127,5.151H60.1L65.895,20.5h4.829l5.795,21.892H72.334Zm-.8-3.058L68.148,23.558,65.895,34.182Z",
    transform: "translate(36.642 12.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-3",
    d: "M86.248,31.285c0,8.853-4.507,11.107-9.175,11.107H71.6V20.5h4.99c4.99,0,9.658,1.61,9.658,10.785M75.624,23.4V39.333h1.61c2.736,0,4.829-1.449,4.829-8.048,0-6.761-2.254-7.887-4.829-7.887h-1.61Z",
    transform: "translate(43.654 12.499)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    className: "cls-3",
    width: 4.024,
    height: 21.892,
    transform: "translate(133.121 32.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-3",
    d: "M98.585,23.4H91.824v6.278H97.78v3.058H91.824v6.6h7.244v3.058H87.8V20.5H99.068Z",
    transform: "translate(53.53 12.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-3",
    d: "M110.926,42.392h-5.151L99.658,24.524c.161,1.932.483,4.668.483,8.692v9.175H96.6V20.5h5.151l6.117,17.868a64.489,64.489,0,0,1-.483-7.4V20.5h3.541Z",
    transform: "translate(58.896 12.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-3",
    d: "M124.468,32.131c0,5.473-1.932,8.692-5.473,8.692a4.959,4.959,0,0,1-4.024-2.254v8.209L113.2,47.1V23.922h1.61l.161,2.415a5.242,5.242,0,0,1,4.346-2.736c3.38,0,5.151,2.9,5.151,8.531m-1.771,0c0-4.99-1.288-7.083-3.7-7.083-1.771,0-2.9,1.288-4.024,2.736V36.8c.966,1.449,2.093,2.576,3.7,2.576,2.575,0,4.024-2.254,4.024-7.244",
    transform: "translate(69.017 14.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-3",
    d: "M134.634,32.192c0,5.473-2.415,8.692-6.117,8.692-3.863,0-6.117-3.058-6.117-8.692s2.415-8.692,6.117-8.692c3.7.161,6.117,2.9,6.117,8.692m-10.463,0c0,4.829,1.61,7.083,4.185,7.083,2.736,0,4.185-2.254,4.185-7.244s-1.61-7.083-4.185-7.083c-2.575.161-4.185,2.254-4.185,7.244",
    transform: "translate(74.626 14.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-3",
    d: "M143,40.38h-1.449l-.161-2.9c-.966,1.932-2.415,3.219-4.507,3.219-2.576,0-4.185-1.771-4.185-4.668V23.8h1.771V35.873c0,2.254.966,3.38,2.736,3.38,1.932,0,3.058-1.449,4.185-3.38V23.8h1.771V40.38Z",
    transform: "translate(80.905 14.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-3",
    d: "M149.683,23.761l-.322,1.61a2.739,2.739,0,0,0-1.127-.161c-1.932,0-3.058,1.61-3.863,4.829v10.3H142.6V23.922h1.449l.161,3.541c.8-2.575,2.093-3.863,4.024-3.863a3.573,3.573,0,0,1,1.449.161",
    transform: "translate(86.941 14.389)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    className: "cls-3",
    width: 0.966,
    height: 11.268,
    transform: "translate(68.573 98.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    className: "cls-3",
    d: "M50.473,65.275v6.117h-.966V65.436c0-1.449-.483-1.932-1.288-1.932-.966,0-1.61.644-2.254,1.771v6.117H45V62.861h.8l.161,1.449A2.818,2.818,0,0,1,48.38,62.7c1.288,0,2.093.966,2.093,2.575",
    transform: "translate(27.436 38.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    className: "cls-3",
    d: "M55.573,65.275v6.117h-.966V65.436c0-1.449-.483-1.932-1.288-1.932-.966,0-1.61.644-2.254,1.771v6.117H50.1V62.861h.8l.161,1.449A2.818,2.818,0,0,1,53.48,62.7c1.449,0,2.093.966,2.093,2.575",
    transform: "translate(30.545 38.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-3",
    d: "M61.239,67.107c0,2.9-1.288,4.507-3.219,4.507S54.8,70,54.8,67.107,56.088,62.6,58.019,62.6s3.219,1.61,3.219,4.507m-5.312,0c0,2.575.8,3.7,2.254,3.7s2.254-1.127,2.254-3.7-.8-3.7-2.254-3.7-2.254,1.127-2.254,3.7",
    transform: "translate(33.411 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-3",
    d: "M63.363,71.331H62.236L59.5,62.8h.966l2.254,7.726L64.812,62.8h.966Z",
    transform: "translate(36.276 38.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-3",
    d: "M70.056,67.468h-4.99c.161,2.415.966,3.38,2.254,3.38a2.666,2.666,0,0,0,1.932-.8l.483.483a3.423,3.423,0,0,1-2.415,1.127c-1.932,0-3.219-1.449-3.219-4.346S65.227,62.8,67.158,62.8s2.9,1.449,2.9,4.185c0,0,0,.322,0,.483M69.09,66.5c0-1.932-.644-3.058-1.932-3.058-1.127,0-1.932.966-2.093,3.38H69.09Z",
    transform: "translate(39.081 38.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-3",
    d: "M72.9,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H69.2V62.761H70l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a.968.968,0,0,0,.644.161",
    transform: "translate(42.19 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    className: "cls-3",
    d: "M73.61,68a.862.862,0,0,1-.8.8A.76.76,0,0,1,72,68a.8.8,0,0,1,1.61,0",
    transform: "translate(43.897 40.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    className: "cls-3",
    d: "M82.939,62.127l-.483.483a2.97,2.97,0,0,0-1.932-.8c-1.61,0-3.058,1.288-3.058,4.99,0,3.541,1.288,4.99,2.9,4.99a2.868,2.868,0,0,0,2.093-.966l.483.644a3.5,3.5,0,0,1-2.575,1.127c-2.254,0-3.863-1.932-3.863-5.795C76.5,62.771,78.271,61,80.524,61a3.423,3.423,0,0,1,2.415,1.127",
    transform: "translate(46.641 37.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    className: "cls-3",
    d: "M85.3,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H81.6V62.761h.8l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a1.217,1.217,0,0,0,.644.161",
    transform: "translate(49.75 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-3",
    d: "M90.939,67.107c0,2.9-1.288,4.507-3.219,4.507S84.5,70,84.5,67.107,85.788,62.6,87.719,62.6c2.093.161,3.219,1.61,3.219,4.507m-5.312,0c0,2.575.8,3.7,2.254,3.7s2.254-1.127,2.254-3.7-.8-3.7-2.254-3.7-2.254,1.127-2.254,3.7",
    transform: "translate(51.518 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-3",
    d: "M89,61.971,90.771,60.2h.644l1.771,1.771-.322.483L91.093,61l-1.771,1.449Zm2.575,10.946H90.61V64.385h.966Z",
    transform: "translate(54.262 36.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-3",
    d: "M96.329,71.863a2.719,2.719,0,0,1-1.61.483,1.86,1.86,0,0,1-1.932-1.932V64.458H91.5v-.8h1.288V61.561l.966-.161v2.093h1.932l-.161.8H93.754v6.117c0,.8.322,1.288,1.127,1.288a2.327,2.327,0,0,0,1.127-.322Z",
    transform: "translate(55.786 37.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-3",
    d: "M99.1,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H95.4V62.761h.8l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a.968.968,0,0,0,.644.161",
    transform: "translate(58.164 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-3",
    d: "M104.256,67.468h-4.99c.161,2.415.966,3.38,2.254,3.38a2.666,2.666,0,0,0,1.932-.8l.483.483a3.423,3.423,0,0,1-2.415,1.127c-1.932,0-3.219-1.449-3.219-4.346s1.127-4.507,3.058-4.507,2.9,1.449,2.9,4.185c0,0,0,.322,0,.483m-.966-.966c0-1.932-.644-3.058-1.932-3.058-1.127,0-2.093.966-2.093,3.38h4.024Z",
    transform: "translate(59.932 38.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-3",
    d: "M104.51,68a.862.862,0,0,1-.8.8.76.76,0,0,1-.8-.8.862.862,0,0,1,.8-.8c.483.161.8.483.8.8",
    transform: "translate(62.737 40.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    className: "cls-3",
    d: "M113.756,64.48c0,2.415-1.449,3.541-4.024,3.541h-.966v4.346H107.8V61.1h1.932c2.575,0,4.024,1.127,4.024,3.38m-1.127,0c0-1.932-.966-2.575-2.9-2.575h-.966v5.312h.966c1.932,0,2.9-.644,2.9-2.736",
    transform: "translate(65.724 37.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-3",
    d: "M116.4,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H112.7V62.761h.8l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a.968.968,0,0,0,.644.161",
    transform: "translate(68.712 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-3",
    d: "M122.039,67.107c0,2.9-1.288,4.507-3.219,4.507S115.6,70,115.6,67.107s1.288-4.507,3.219-4.507c1.932.161,3.219,1.61,3.219,4.507m-5.473,0c0,2.575.8,3.7,2.254,3.7s2.254-1.127,2.254-3.7-.8-3.7-2.254-3.7c-1.288,0-2.254,1.127-2.254,3.7",
    transform: "translate(70.48 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-3",
    d: "M125.712,63.727l-.483.483a2.97,2.97,0,0,0-1.932-.8c-.966,0-1.61.483-1.61,1.449,0,.8.483,1.127,1.771,1.61,1.61.483,2.415,1.127,2.415,2.576a2.456,2.456,0,0,1-2.736,2.415,3.606,3.606,0,0,1-2.736-1.127l.483-.483a3.39,3.39,0,0,0,2.093.8,1.654,1.654,0,0,0,1.771-1.61c0-.966-.483-1.449-1.932-1.932-1.61-.483-2.254-1.127-2.254-2.254a2.339,2.339,0,0,1,2.415-2.254,4.73,4.73,0,0,1,2.736,1.127",
    transform: "translate(73.406 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-3",
    d: "M130.895,67.046c0,2.9-.966,4.507-2.736,4.507a2.512,2.512,0,0,1-2.093-1.127v4.185l-.966.161V62.861h.8v1.288a2.726,2.726,0,0,1,2.254-1.449c1.932,0,2.736,1.449,2.736,4.346m-.966,0c0-2.575-.644-3.7-1.932-3.7a2.48,2.48,0,0,0-2.093,1.449v4.668a2.271,2.271,0,0,0,1.932,1.288c1.449,0,2.093-1.127,2.093-3.7",
    transform: "translate(76.272 38.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-3",
    d: "M135.756,69.053h-4.99c.161,2.415.966,3.38,2.254,3.38a2.666,2.666,0,0,0,1.932-.8l.483.483a3.423,3.423,0,0,1-2.415,1.127c-1.932,0-3.219-1.449-3.219-4.346s1.127-4.507,3.058-4.507,2.9,1.449,2.9,4.185v.483m-.966-.966c0-1.932-.644-3.058-1.932-3.058-1.127,0-1.932.966-2.093,3.38h4.024Zm-3.219-5.795-.322-.483,2.575-1.61.483.8Z",
    transform: "translate(79.137 36.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-3",
    d: "M138.6,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H134.9V62.761h.8l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a.968.968,0,0,0,.644.161",
    transform: "translate(82.247 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-3",
    d: "M143.756,67.468h-4.99c.161,2.415.966,3.38,2.254,3.38a2.666,2.666,0,0,0,1.932-.8l.483.483a3.423,3.423,0,0,1-2.415,1.127c-1.932,0-3.219-1.449-3.219-4.346s1.127-4.507,3.058-4.507,2.9,1.449,2.9,4.185v.483m-.8-.966c0-1.932-.644-3.058-1.932-3.058-1.127,0-1.932.966-2.093,3.38h4.024Z",
    transform: "translate(84.015 38.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-3",
    d: "M146.6,62.761l-.161.8c-.161,0-.322-.161-.644-.161-.966,0-1.61.8-1.932,2.576v5.312H142.9V62.761h.8l.161,1.771c.483-1.288,1.127-1.932,2.093-1.932a.968.968,0,0,0,.644.161",
    transform: "translate(87.124 38.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-3",
    d: "M147.31,68a.862.862,0,0,1-.8.8.76.76,0,0,1-.8-.8.862.862,0,0,1,.8-.8c.483.161.8.483.8.8",
    transform: "translate(88.831 40.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-4",
    d: "M62.617,10.854c0-1.288-.644-2.254-1.449-2.254H1.449C.644,8.6,0,9.727,0,10.854v3.863C0,16,.644,16.97,1.449,16.97H61.168c.8,0,1.449-.966,1.449-2.254Z",
    transform: "translate(0 5.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-4",
    d: "M62.617,2.254C62.617.966,61.973,0,61.168,0H1.449C.644,0,0,.966,0,2.254V6.117C0,7.4.644,8.37,1.449,8.37H61.168c.8,0,1.449-.966,1.449-2.254Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCapFr);
export default __webpack_public_path__ + "static/media/logo-cap-fr.0cf0759964d0486c27899978eca701d5.svg";
export { ForwardRef as ReactComponent };